export type FileKind = 'docx' | 'pdf' | 'xlsx' | 'image' | 'other';

const BY_TYPE: Record<string, FileKind> = {
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  // Raster only — the server refuses image/svg+xml inline (it can carry script), so an SVG
  // is 'other' here and gets the honest "download it to open it" message.
  'image/png': 'image',
  'image/jpeg': 'image',
  'image/gif': 'image',
  'image/webp': 'image',
};

const BY_EXT: Record<string, FileKind> = {
  pdf: 'pdf', docx: 'docx', xlsx: 'xlsx',
  png: 'image', jpg: 'image', jpeg: 'image', gif: 'image', webp: 'image',
};

/**
 * Classify a file-backed vault document by content type, falling back to the filename
 * extension when the type is generic/missing. The ONE place upload format routing is
 * decided — the edit screen uses it to pick the in-app Word editor (`docx`) vs the
 * replace-file card (`pdf`/`xlsx`/`image`/`other`), and the viewer uses it to pick the
 * PDF renderer, the image renderer, or the "can't show this" message.
 */
export function fileKind(
  contentType: string | null | undefined,
  filename: string | null | undefined,
): FileKind {
  const type = (contentType ?? '').toLowerCase();
  if (BY_TYPE[type]) return BY_TYPE[type];
  const ext = (filename ?? '').toLowerCase().split('.').pop() ?? '';
  return BY_EXT[ext] ?? 'other';
}
